var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2286 9.62813V12.5881C13.2285 13.0069 13.062 13.4086 12.7659 13.7047C12.4697 14.0008 12.0681 14.1673 11.6493 14.1675H3.9153C3.70713 14.1674 3.50104 14.1262 3.30886 14.0462C3.11667 13.9662 2.94219 13.849 2.79543 13.7014C2.64867 13.5538 2.53253 13.3786 2.45368 13.1859C2.37483 12.9933 2.33482 12.787 2.33597 12.5788V4.85347C2.33473 4.64563 2.37475 4.43962 2.45371 4.24736C2.53268 4.05511 2.64901 3.88044 2.79598 3.73348C2.94294 3.58651 3.11761 3.47018 3.30986 3.39121C3.50212 3.31225 3.70813 3.27223 3.91597 3.27347H6.8753",
    stroke: "#50C878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2325 5.99974L10.5092 3.27574M5.0625 10.5384V9.09507C5.06383 8.85707 5.1585 8.6284 5.32583 8.45974L11.6805 2.10507C11.7648 2.01981 11.8652 1.95212 11.9759 1.90592C12.0865 1.85972 12.2053 1.83594 12.3252 1.83594C12.4451 1.83594 12.5638 1.85972 12.6745 1.90592C12.7851 1.95212 12.8855 2.01981 12.9698 2.10507L14.4038 3.53907C14.4891 3.62339 14.5568 3.72378 14.603 3.83444C14.6492 3.9451 14.673 4.06382 14.673 4.18374C14.673 4.30365 14.6492 4.42237 14.603 4.53303C14.5568 4.64369 14.4891 4.74408 14.4038 4.8284L8.04917 11.1831C7.88019 11.3509 7.65198 11.4455 7.41383 11.4464H5.9705C5.85121 11.4466 5.73306 11.4232 5.62282 11.3776C5.51257 11.3321 5.41241 11.2652 5.32806 11.1808C5.24371 11.0965 5.17683 10.9963 5.13126 10.8861C5.08569 10.7758 5.06233 10.6577 5.0625 10.5384Z",
    stroke: "#50C878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenEditIcon);
export default __webpack_public_path__ + "static/media/greenEditIcon.59f04a2db752e6cf59d74686e8dabec6.svg";
export { ForwardRef as ReactComponent };